import { styled } from "@mui/material/styles";

import { ProductQuery } from "../../../apiHooks/graphql";
import { useNextTranslation } from "../../../hooks";
import { ProductBookNowButton, ProductBookNowButtonProps } from "../../../product/ProductBookNowButton";
import { AvailabilityExternalWidget } from "../AvailabilityExternalWidget";
import { AvailabilityTrigger } from "./AvailabilityTrigger";
import { ExternalWidgetAvailability } from "./ExternalWidgetAvailability";

const AvailabilityButton = styled(ProductBookNowButton)(({ theme }) => ({
    borderRadius: theme.roundness,
}));

function ExternalWidgetAvailabilityButton(props: ProductBookNowButtonProps) {
    return <AvailabilityButton size="medium" data-leave-me-alone="true" {...props} />;
}

type AvailabilityV2Props = {
    product: ProductQuery["product"];
    onContentTrigger: () => void;
    availability?: string | null;
};
export const CheckAvailabilityButtonV2 = (props: AvailabilityV2Props) => {
    const { product, onContentTrigger, availability } = props;
    const [t] = useNextTranslation("availability");

    if (product.isOffSale) {
        // Please do not remove this console.log since it is needed for debug purposes.
        console.log({ productOffSaleReasonList: product.offSaleReasonList });
        return (
            <AvailabilityButton size="medium" disabled={true}>
                {t("form.notAvailable.label")}
            </AvailabilityButton>
        );
    }

    if (product.availabilityType === "EXTERNAL_WIDGET" && product.externalWidgetData) {
        const externalWidget = (
            <AvailabilityExternalWidget
                widget={product.externalWidgetData}
                ButtonComponent={ExternalWidgetAvailabilityButton}
                onOpen={onContentTrigger}
            />
        );

        if (product.externalWidgetData.__typename === "ExternalWidgetRezdy") {
            return <ExternalWidgetAvailability onClick={onContentTrigger} />;
        }

        return externalWidget;
    }

    return <AvailabilityTrigger onContentTrigger={onContentTrigger} product={product} availability={availability} />;
};
